import c from 'classnames';
import { download } from 'core/api/certificate';
import { useLinks } from 'core/components/linksContext';
import { SettingsContext } from 'core/components/settingsContext';
import { showSnackbar } from 'core/components/snackbar';
import { ieFix } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Certificate, CertificatePublicStateEnum, CertificateToAccount } from 'site/graphql';
import { formItemCardStyles } from './formItemCardStyles';

type IPrivateProductCertificateCardProps = {
    certificate: Pick<Certificate, 'id' | 'state'> & {
        myCertificate?: Pick<CertificateToAccount, 'number'>;
    };
    noAccess: boolean;
} & WithStyles<typeof styles>;

const PrivateProductCertificateCard: React.FC<IPrivateProductCertificateCardProps> = ({
    classes,
    certificate,
    noAccess,
}) => {
    const links = useLinks();
    const history = useHistory();
    const { endPoint } = useContext(SettingsContext);

    const isCertReady = certificate.state === CertificatePublicStateEnum.CanDownload;
    const needConditions = certificate.state === CertificatePublicStateEnum.NeedCondidtions;
    const handleClick = () => {
        if (noAccess) {
            history.push(links.courseList.url());
            return;
        }

        showSnackbar({ snackbarMessage: 'Сертификат создан' });
        setTimeout(() => download({ certificateId: certificate.id, endPoint }), 1000);
    };

    return (
        <div className={c(classes.root, { [classes.darkenedRoot]: noAccess })}>
            <div className={classes.content}>
                <h4 className={classes.typeName}>Сертификат</h4>
                {isCertReady && certificate.myCertificate ? (
                    <h3 className={classes.certificateName}>№ {certificate.myCertificate.number}</h3>
                ) : (
                    <h3 className={classes.certificateName}>—</h3>
                )}
                {isCertReady ? (
                    <a className={classes.button} onClick={handleClick}>
                        {noAccess ? 'Открыть доступ' : 'Загрузить сертификат'}
                    </a>
                ) : needConditions ? (
                    <span className={classes.spanDownloadLink}>
                        Для загрузки сертификата необходимо заполните ФИО в{' '}
                        <Link to={`${links.account.url()}profile`}>профиле</Link>
                    </span>
                ) : (
                    <span className={classes.spanDownloadLink}>Вы получите сертификат после окончания курса</span>
                )}
            </div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        ...formItemCardStyles(theme),
        typeName: {
            color: theme.colors.textLight,
            textAlign: 'center',
            fontWeight: 400,
            marginTop: 0,
        },
        certificateName: {
            textAlign: 'center',
            fontWeight: 400,
            marginTop: 0,
        },
        spanDownloadLink: {
            flex: 1,
            textAlign: 'center',

            ...ieFix({ flex: 'none' }),
        },
    });

export default injectSheet(styles, 'PrivateProductCertificateCard')(PrivateProductCertificateCard);
